import { baseUrl } from './routes';

export class LocationRolesRoutes {
  static get locationRoles(): string {
    return `${baseUrl}/location-roles`;
  }
  static get register(): string {
    return `${baseUrl}/location-roles/register`;
  }
  static get list(): string {
    return `${baseUrl}/location-roles/list`;
  }
  static get edit(): string {
    return `${baseUrl}/location-roles/list/edit`;
  }
}